import {omniboxMetadata} from '@tableau/omnibox-common/lib/src/Metadata';
import { startMicroview } from '@tableau/microview';
import { OmniboxV2, OmniboxProps } from './omnibox/components/OmniboxV2';

startMicroview<OmniboxProps>(
    omniboxMetadata,
    OmniboxV2
);